<template>
  <b-card>
    <FormView
      :data="$store.getters['administratorV2/detailData']"
      :fields="$store.getters['administratorV2/tableFields']"
      @load="loadData"
    />
  </b-card>
</template>

<script>
import FormView from '@/layouts/components/v2/FormView.vue'

import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    FormView,
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('administratorV2/getDetail', id)
    },
  },
}
</script>

<style scoped>

</style>
